import { useEffect, useLayoutEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { GlobalLoader } from '@components/loader';
import { SessionOut } from '@components/sessionOutDialog/SessionOut';
import { Toast } from '@components/toast';
import { useStore } from '@stores/RootStore';
import { useGetCategories } from '@queryHooks/useCategory';
import * as S from './EmployeeStyles';
import { Modals } from './common/modals';
import { TopGnb } from './employee/gnb';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// limited token 접근을 허용하는 공개 경로
const PUBLIC_PATHS = ['/login', '/sso-login', '/select-tenant', '/search-password', '/change-password', '/confirm-mail', '/registered-user', '/tenant-request', '/oauth-callback', '/error', '/privacy-policy', '/expired-password-reset-link'];

const isPublicPath = (pathname: string) => PUBLIC_PATHS.some(path => pathname.startsWith(path));

export const Employee = observer(({ enabledOnlyUseLoginPage }: { enabledOnlyUseLoginPage: boolean }) => {
  const { authStore, categoryStore } = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const tenantId = authStore.curTenant.id;

  useLayoutEffect(() => {
    authStore.initialize();
  }, [authStore]);

  // limited token 상태에서 로그인 플로우 밖으로 이탈 시 로그아웃(토큰 제거)만 처리
  useEffect(() => {
    if (authStore.isLogin && authStore.isLimitedToken && !isPublicPath(location.pathname)) {
      authStore.logout();
    }
  }, [authStore, authStore.isLogin, authStore.isLimitedToken, location.pathname]);

  const handleCloseSessionOut = () => {
    navigate('/login', { state: { routeAfterLogin: location.pathname, tenantId } });
  };

  const { data: categories } = useGetCategories();

  useEffect(() => {
    if (categories) {
      categoryStore.setCategories(categories.content);
    }
  }, [categories, categoryStore]);

  return (
    <div className="app customer">
      {!enabledOnlyUseLoginPage && <TopGnb />}
      <Main>
        <S.ContentsWrapper>
          <Outlet />
        </S.ContentsWrapper>
        <SessionOut onClose={handleCloseSessionOut} />
      </Main>
      <Modals />
      <GlobalLoader />
      <Toast />
    </div>
  );
});

const Main = styled.div`
  width: 100%;
  padding-top: var(--employee-gnb-height);
  ${({ theme }) => theme.breakpoints.between('xxs', 'sm')} {
    padding-top: var(--mobile-employee-gnb-height);
  }
`;
